import { render, staticRenderFns } from "./address.vue?vue&type=template&id=6fa701f5&scoped=true"
import script from "./address.vue?vue&type=script&lang=js"
export * from "./address.vue?vue&type=script&lang=js"
import style0 from "./address.vue?vue&type=style&index=0&id=6fa701f5&prod&scoped=true&lang=css"
import style1 from "./address.vue?vue&type=style&index=1&id=6fa701f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa701f5",
  null
  
)

export default component.exports